import { render, staticRenderFns } from "./shareBox.vue?vue&type=template&id=3164dae8&scoped=true&"
import script from "./shareBox.vue?vue&type=script&lang=js&"
export * from "./shareBox.vue?vue&type=script&lang=js&"
import style0 from "./shareBox.vue?vue&type=style&index=0&id=3164dae8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3164dae8",
  null
  
)

export default component.exports